import { Box, Flex } from "@chakra-ui/react";
import { Route, Routes } from "react-router-dom";
import { ErrorPage } from "./pages/ErrorPage";
import { Footer } from "./components/Footer";
import { MainSiteLayout } from "./layout/MainSiteLayout";
import { NavBar } from "./components/NavBar";
import { ParkPage } from "./pages/ParkPage";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { TermsAndConditions } from "./pages/TermsAndConditions";
import { BLUE_COLOR } from "./const";
import { useScrollToTop } from "./hooks/useScrollToTop";
import { CountyInformation } from "./pages/CountyInformation";
import { AreasLayout } from "./layout/AreasLayout";
import { Home } from "./pages/Home";
import { CaravanPage } from "./pages/CaravanPage";
import { CountyLayout } from "./layout/CountyLayout";
import { CookiePolicy } from "./pages/CookiePolicy";
import { Blog } from "./components/Blog";
import { useInvalidateOnVersionChange } from "./hooks/useInvalidateOnVersionChange";
import { AreaListModal } from "./components/AreaListModal";
import { Insurance } from "./pages/Insurance";
import { Helmet } from "react-helmet";

export const App: React.FC = () => {
  useScrollToTop();
  useInvalidateOnVersionChange();

  const isWhiteLabel = window.location.hostname !== "holidayhomes.breakfreeholidays.co.uk";

  return (
    <>
      {isWhiteLabel && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}

      <AreaListModal />

      <Flex flexDir="column" minHeight="100vh">
        {/* Header */}
        <Box bg={BLUE_COLOR} minH="42px" h="42px" w="100%" />
        <NavBar />

        {/* Main content */}
        <Box flex={1}>
          <Routes>
            <Route element={<MainSiteLayout />}>
              <Route path="/" element={<Home />} />

              <Route path="/areas" element={<AreasLayout />}>
                <Route index element={<AreaListModal forceOpen />} />
                <Route element={<CountyLayout />}>
                  <Route path=":county" element={<CountyInformation />} />
                  <Route path=":county/:park" element={<ParkPage />} />
                  <Route path=":county/:park/:caravan" element={<CaravanPage />} />
                </Route>
              </Route>
            </Route>

            <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/insurance" element={<Insurance />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </Box>

        {/* Footer */}
        <Footer />
      </Flex>
    </>
  );
};
